exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content.clients-journey {\n    max-width: 100%;\n    padding-bottom: 0;\n    overflow: hidden;\n}\n", ""]);

// exports
